
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'TabsComponent',
  props: {
    tabs: {
      type: Object as PropType<Array<{ name: string, label: string}>>,
      required: true,
    },
    selectedValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:tab', 'change'],
  setup(props, { emit }) {

    const selectTab = (name: string) => {
        emit('change', name)
    }

    return { selectTab }
  }
})
